import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import List from "./list";
import Edit from "./edit";

export default class Index extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/interfacetexts" component={List}/>
                    <Route path="/interfacetexts/create" component={Edit}/>
                    <Route path="/interfacetexts/:id" component={Edit}/>
                </Switch>
        )
    }
}
